export default "__VITE_ASSET__Dy$nGa64__"